import Heading from '@shared/components/common/Heading';
import { cn } from '@shared/utils/utils';

type Props = {
    title: string,
    className?: string,
    fields: {
        label: string,
        value: string,
        labelClassName?: string,
        onClick?: () => void,
        helperText?: string
    }[]
};

const ProfileInfoCard = ({ title, className, fields }: Props) => {
    return (
        <div className={cn('bg-white rounded-lg p-6 shadow-md space-y-1', className)}>
            <Heading variant='h4'>{title}</Heading>
            <ul className='space-y-0 [&>li:not(:last-child)]:border-b border-border'>
                {fields.map((field, index) => {
                    const isLast = index === fields.length - 1;
                    return (
                        <li key={index}>
                            <div className={cn('flex py-6 gap-4', isLast && 'pb-0')}>
                                <span className='w-32 md:w-60 text-[#999]'>{field.label}</span>
                                <div className='flex-1 space-y-1.5'>
                                    <p className={cn('line-clamp-2 break-all', field.labelClassName)} onClick={field.onClick}>{field.value}</p>
                                    {field.helperText && <p className='text-danger text-sm'>{field.helperText}</p>}
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ProfileInfoCard;
